import React, { useContext, useState, useEffect } from "react";
import {
  GridContainer,
  AcquirerListRootArea,
  GridItem,
} from "./Merchant.styles";
import { Button, Typography, Tabs, Tab, Box } from "@mui/material";
import DataTable from "../../dataTable/DataTable";
import ListSearchField from "../../listSearchField/ListSearchField";
import { useEffectOnce } from "../../../utils/effects";
import AuthContext from "../../../context/AuthContext";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { useDispatch, useSelector } from "react-redux";
import LoadEnrollment from "../LoadEnrollment/LoadEnrollment";
import {
  getMerchantList,
  getTerminalList,
  deleteTerminal,
  sendMerchantModifyBilling,
  sendMerchantModifyWalletConfirmation,
} from "./Merchant.thunk";
import { setMerchantId } from "../Exchanges/Exchanges.slice";
import { resetStoreItem } from "./Merchant.slice";
import { useConfirmModal } from "../../confirmModal/useConfirmModal";
import AddTerminalDialog from "../../forms/terminal_edit/AddTerminalDialog";
import { useSnackbar } from "../../snackbar/useSnackbar";
import {
  setTerminalItemInfo,
  configureForm,
} from "../../forms/MerchantAndTerminals/MerchantAndTerminals.slice";
import AdminFields from "../../adminFields/AdminFields";
import {
  setWasUsed,
  setApplyChanges,
  setReset,
} from "../../adminFields/AdminFields.slice";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { IconButton } from "@mui/material";

const MerchantList = (props) => {
  const {
    // setSubmenuAdministrativeOpen,
    setSubmenuMerchantTerminal,
    setSelectedOption,
    setNameSection,
    mode = "iso_search",
  } = props;

  const dispatch = useDispatch();
  const { showConfirmModal } = useConfirmModal();
  const { showCustom } = useSnackbar();

  const {
    merchantList,
    status,
    screenMode,
    terminalList,
    merchantID,
    terminalDetails,
    terminalDetailStatus,
    page,
    pageSize,
    totalRecords,
  } = useSelector((state) => state.merchantList);
  const {
    token,
    userInfo: { "acquirer-rol-data": userRole },
    acquirerData: { acquirerId, isoID, acquirerName },
  } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(0);
  const [severity, setSeverity] = useState("");
  const [messageSnack, setMessageOpen] = useState("");
  const [openSnack, setSnackOpen] = useState(false);
  const [terminalDialogOpen, setTerminalDialogOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");

  const buildListPayload = (overrides = {}) => {
    const search = "search" in overrides ? overrides.search : appliedSearch;
    return {
      token,
      acquirerId: overrides.acquirerId ?? acquirerId,
      isoID: overrides.isoID ?? isoID,
      mode,
      acquirerName,
      page: overrides.page ?? page,
      page_size: overrides.page_size ?? pageSize,
      ...(search && { search }),
      ...(overrides.onSuccess && { onSuccess: overrides.onSuccess }),
    };
  };

  const loadList = (overrides = {}) => {
    dispatch(getMerchantList(buildListPayload(overrides)));
  };

  const handleSearch = () => {
    const nextSearch = searchValue.trim();
    setAppliedSearch(nextSearch);
    loadList({ page: 1, search: nextSearch });
  };

  const handleClearSearch = () => {
    setSearchValue("");
    setAppliedSearch("");
    loadList({ page: 1, search: "" });
  };

  const {
    applyChanges,
    acquirerId: storeAcquirerId,
    isoID: storeIsoID,
    wasUsed,
    reset,
  } = useSelector((state) => state.adminFields);

  const resetToast = () => {
    setSnackOpen(false);
    setMessageOpen("");
    setSeverity("");
  };

  const handleCloseTerminalDialog = () => {
    setTerminalDialogOpen(false);
  };

  useEffect(() => {
    if (openSnack && messageSnack && severity) {
      showCustom(messageSnack, severity);
      resetToast();
    }
  }, [openSnack, messageSnack, severity]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffectOnce(() => {
    loadList();
  });

  // Admin fields logic start ===============================
  useEffect(() => {
    const updateAdminFieldsControlData = () => {
      dispatch(setApplyChanges(false));
      dispatch(setWasUsed(true));
    };
    const getMerchantListCustom = async () => {
      loadList({
        acquirerId: storeAcquirerId,
        isoID: storeIsoID,
        onSuccess: updateAdminFieldsControlData,
      });
    };
    if (applyChanges) {
      getMerchantListCustom();
    }
  }, [applyChanges]);

  useEffect(() => {
    if (reset) {
      loadList({ acquirerId, isoID });
      dispatch(setReset(false));
    }
  }, [reset]);
  // Admin fields logic end ===============================

  const handleEdit = async (row) => {
    const terminalItemInfo = {
      acquirerData: { acquirerId, acquirerName },
      merchantID,
      terminalID: row.acquirerTerminalID,
    };
    await dispatch(
      setTerminalItemInfo({
        formType: "editTerminal",
        readOnlyForm: false,
        terminalItemInfo,
      }),
    );
    setSubmenuMerchantTerminal("merchant_terminal_new");
    setSelectedOption("merchant_terminal_new");
    setNameSection("Merchant & Terminal - Terminal Edit");
  };

  const handleSee = async (row) => {
    const terminalItemInfo = {
      acquirerData: { acquirerId, acquirerName },
      merchantID,
      terminalID: row.acquirerTerminalID,
    };
    await dispatch(
      setTerminalItemInfo({
        formType: "seeTerminal",
        readOnlyForm: true,
        terminalItemInfo,
      }),
    );
    setSubmenuMerchantTerminal("merchant_area");
    setSelectedOption("merchant_terminal_new");
    setNameSection("Merchant & Terminal - Terminal Details");
  };

  const handleAdd = () => {
    dispatch(configureForm({}));
    setSubmenuMerchantTerminal("merchant_area");
    setSelectedOption("merchant_terminal_new");
    setNameSection("Merchant & Terminal - Enrollment");
  };

  const handleAddTerminal = () => {
    setTerminalDialogOpen(true);
  };

  const handleBack = () => {
    dispatch(resetStoreItem());
  };

  const handleShow = async (merchantID) => {
    await dispatch(
      getTerminalList({
        token,
        acquirerId:
          !applyChanges && wasUsed && !reset ? storeAcquirerId : acquirerId,
        merchantID: merchantID,
        acquirerName,
      }),
    );
    // setAcquirerId(acquirer_id);
  };

  const handleDeleteTerminal = (terminalID) => {
    showConfirmModal({
      message:
        "Are you sure you want to delete this terminal? This action cannot be undone.",
      actionId: "delete-terminal",
      title: "Delete Terminal",
      onConfirm: () => {
        dispatch(
          deleteTerminal({
            token,
            acquirerId,
            merchantID,
            acquirerName,
            terminalIDs: terminalID,
          }),
        );
      },
    });
  };

  const handleDisableBillingArea = ({ merchantID, allowBilling }) => {
    dispatch(
      sendMerchantModifyBilling({
        token,
        merchantId: merchantID,
        allowBilling: !allowBilling,
        onSuccess: () => {
          loadList();
        },
      }),
    );
  };

  const handleDisableWalletConfirmation = ({
    merchantID,
    walletValidation,
  }) => {
    dispatch(
      sendMerchantModifyWalletConfirmation({
        token,
        merchantId: merchantID,
        walletValidation: !walletValidation,
        onSuccess: () => {
          loadList();
        },
      }),
    );
  };

  const generalColumns = [
    { id: "merchantID", label: "ID" },
    { id: "merchantName", label: "Merchant Name" },
    { id: "merchantStatus", label: "Merchant Status" },
    {
      id: "action",
      label: "Actions",
      actions: [
        ({ allowBilling, merchantID, hasTerminalTypeE }) => {
          return ["admin", "acquirer", "ISO"].includes(userRole) &&
            hasTerminalTypeE ? (
            <IconButton
              title={`${!allowBilling ? "Enable" : "Disable"} Billing Area`}
              onClick={() =>
                handleDisableBillingArea({ merchantID, allowBilling })
              }
            >
              <CreditCardOffIcon color={allowBilling ? "primary" : "error"} />
            </IconButton>
          ) : null;
        },
        ({ allowBilling, merchantID, walletValidation, hasTerminalTypeE }) => {
          return ["admin", "acquirer", "ISO"].includes(userRole) &&
            allowBilling &&
            hasTerminalTypeE ? (
            <IconButton
              title={`${
                !walletValidation ? "Enable" : "Disable"
              } Wallet Confirmation`}
              onClick={() =>
                handleDisableWalletConfirmation({
                  merchantID,
                  walletValidation,
                })
              }
            >
              <FactCheckIcon color={walletValidation ? "primary" : "error"} />
            </IconButton>
          ) : null;
        },
        {
          icon: <VisibilityIcon />,
          label: "View Terminals",
          onClick: ({ merchantID }) => {
            handleShow(merchantID);
          },
        },
        {
          icon: <CurrencyExchangeIcon />,
          label: "View Exchanges",
          onClick: ({ merchantID }) => {
            dispatch(setMerchantId(merchantID));
            setSubmenuMerchantTerminal("merchant_area");
            setSelectedOption("exchanges");
            setNameSection("Merchant & Terminal - Exchanges");
          },
        },
      ],
    },
  ];

  const itemColumns = (terminalList = []) => [
    { id: "acquirerTerminalID", label: "Terminal ID" },
    { id: "terminalType", label: "Terminal Type" },
    { id: "terminalStatus", label: "Terminal Status" },
    {
      id: "action",
      label: "Actions",
      actions: [
        {
          icon: <VisibilityIcon />,
          label: "View Terminals Detail",
          onClick: (row) => handleSee(row),
        },
        {
          icon: <EditIcon />,
          label: "Edit Terminals",
          onClick: (row) => handleEdit(row),
        },
        ...(terminalList && terminalList?.length > 1
          ? [
              {
                icon: <DeleteIcon />,
                label: "Delete Terminals",
                onClick: ({ acquirerTerminalID }) => {
                  handleDeleteTerminal(acquirerTerminalID);
                },
              },
            ]
          : []),
      ],
    },
  ];

  const handleOnCreated = () => {
    dispatch(
      getTerminalList({
        token,
        acquirerId,
        merchantID: merchantID,
        acquirerName,
      }),
    );
  };

  const handlePageChange = (event, newPage) => {
    loadList({ page: newPage + 1 });
  };

  const handleRowsPerPageChange = (event) => {
    const newPageSize = +event.target.value;
    loadList({ page: 1, page_size: newPageSize });
  };

  return (
    <AcquirerListRootArea>
      {/* <AdminFields /> */}
      <GridContainer>
        <GridContainer
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2, mt: 2, flexWrap: "wrap", gap: 1 }}
        >
          <GridItem xs={12} sm="auto" sx={{ minWidth: 0 }}>
            <Typography variant="h6">
              {screenMode === "general" ? "Merchants" : "Terminals"}
            </Typography>
          </GridItem>
          <GridItem xs={12} sm="auto">
            <Box
              sx={{
                display: "flex",
                gap: 1,
                justifyContent: { xs: "flex-start", sm: "flex-end" },
                flexWrap: "nowrap",
              }}
            >
              {screenMode === "item" && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleBack}
                  size="small"
                  sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                >
                  Back
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={
                  screenMode === "general" ? handleAdd : handleAddTerminal
                }
                size="small"
                disabled={
                  screenMode === "item" && terminalDetailStatus !== "succeeded"
                }
                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
              >
                Add
              </Button>
            </Box>
          </GridItem>
        </GridContainer>

        {/* Tabs */}
        <GridItem xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="merchant tabs"
            >
              <Tab label="Active" />
              <Tab label="In Progress" disabled={!(screenMode === "general")} />
            </Tabs>
          </Box>
        </GridItem>

        {/* Tab Content */}
        <GridItem xs={12}>
          {activeTab === 0 && (
            <Box sx={{ mt: 2 }}>
              {screenMode === "general" && (
                <Box sx={{ mb: 2, maxWidth: { xs: "100%", sm: 360 } }}>
                  <ListSearchField
                    fullWidth
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onSearch={handleSearch}
                    placeholder="Merchant ID or name"
                  />
                </Box>
              )}
              <DataTable
                loading={status === "loading"}
                columns={
                  screenMode === "general"
                    ? generalColumns
                    : screenMode === "item"
                      ? itemColumns(terminalList)
                      : []
                }
                rows={
                  screenMode === "general"
                    ? merchantList
                    : screenMode === "item"
                      ? terminalList
                      : []
                }
                page={screenMode === "general" ? page - 1 : undefined}
                rowsPerPage={screenMode === "general" ? pageSize : undefined}
                count={screenMode === "general" ? totalRecords : undefined}
                onPageChange={
                  screenMode === "general" ? handlePageChange : undefined
                }
                onRowsPerPageChange={
                  screenMode === "general" ? handleRowsPerPageChange : undefined
                }
              />
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ mt: 2 }}>
              <LoadEnrollment
                setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
                setSelectedOption={setSelectedOption}
                setNameSection={setNameSection}
              />
            </Box>
          )}
        </GridItem>
      </GridContainer>
      <AddTerminalDialog
        open={terminalDialogOpen}
        onClose={handleCloseTerminalDialog}
        merchantDetails={terminalDetails}
        merchant={terminalDetails}
        onCreated={handleOnCreated}
        setMessageOpen={setMessageOpen}
        setSnackOpen={setSnackOpen}
        setSeverity={setSeverity}
      />
    </AcquirerListRootArea>
  );
};

export default MerchantList;
